import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import ArticleDate, { ArticleDateSize, ArticleDateVariant, } from '@stories/Components/Misc/ArticleDate/ArticleDate';
import * as React from 'react';
import S from './ArticleDetailPageHeroBanner.styles';
const ArticleDetailPageHeroBanner = ({ anchorId, title, date, tags, image, }) => {
    const srcs = getSrcs(image, 731, 339, 6, 3 / 4);
    return (React.createElement(S.Container, { id: anchorId },
        React.createElement(S.Inner, null,
            React.createElement(S.Detail, null,
                React.createElement(S.Title, null, title),
                React.createElement(ArticleDate, { date: date, tags: tags, size: ArticleDateSize.Large, variant: ArticleDateVariant.Black })),
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { sizes: `${until(Device.TabletSmall)} 100vw, ${until(Device.TabletLarge)} 66vw, ${until(Device.DesktopLarge)} 52.5vw, 720px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), role: !image.altText ? 'presentation' : undefined, alt: image.altText })))));
};
export default ArticleDetailPageHeroBanner;
